import { getSkillsListQueryOptions } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

export const skillsQuery = () => getSkillsListQueryOptions({ query: "ordered_by_popularity" });

export const queries = (): Array<WarmableQuery> => [skillsQuery()];
